import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios, { CancelToken } from "axios";
import { useAppDispatch } from "hooks/redux";
import { useHistory, useLocation } from "react-router";

import { 
    GetMinimumSpending,
} from "api/rpc/2024-04/facilityAdmin/accounts/minimumSpending";
import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { valueToString } from "helpers/Helpers";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import { LocaleCurrency } from "helpers/Locale";
import { TMinimumSpend } from "../../customer/context/contextTypes";

export default function MinimumSpending() {

    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const backToAccountsUrl = `/admin/settings/accounts${location.search || ""}`;

    const [minimums, setMinimums] = useState(undefined);

    useEffect(() => {
        const source = axios.CancelToken.source();
        void loadMinimumSpending(source.token);
        return () => source.cancel();
    }, []);

    async function loadMinimumSpending(token?: CancelToken) {
        const res = await GetMinimumSpending(null, false, token);

        if (token && token.reason) {
            return;
        }
        if (res.status !== StatusCode.OK) {
            dispatch(showError("Error loading minimum spending"));
        }

        setMinimums(res.data);
    }

    const primaryAction = {
        content: t("Create Minimum"),
        action: () =>
            history.push({
                pathname: "/admin/settings/accounts/minimum-spending/new",
                search: location.search,
            }),
    };

    return (
        <Page
            title={t("Minimum Spending")}
            primaryAction={primaryAction}
            narrow
            breadcrumbs={[
                {
                    prefix: true,
                    label: t("Accounts"),
                    url: backToAccountsUrl,
                },
            ]}
        >
            <DataTable
                columns={[
                    { label: "Title" },
                    { label: "Amount" },
                    { label: "Structure" },
                    { label: "Categories" },
                    { label: "Accounts" },
                ]}
                loading={minimums === undefined}
            >
                {minimums?.map((minimum: TMinimumSpend) => (
                    <tr
                        className="clickable"
                        key={minimum.id}
                        onClick={() =>
                            history.push({
                                pathname: `/admin/settings/accounts/minimum-spending/${minimum.id}`,
                                search: location.search,
                            })
                        }
                    >
                        <td>{minimum.title}</td>
                        <td><LocaleCurrency amount={minimum.amount} /></td>
                        <td>{valueToString(minimum.structure as string)}</td>
                        <td>{minimum.departments_count}</td>
                        <td>{minimum.accounts_count}</td>
                        {/* <td>{minimum.departments_count}</td>
                        <td>{minimum.accounts_count}</td> */}
                    </tr>
                ))}
            </DataTable>
        </Page>
    );
}